// extracted by mini-css-extract-plugin
export default {"center":"KQss1l","left":"ccCFTS","right":"RmxY96","justifyContentCenter":"q2TQ7M","justifyContentLeft":"QXVfuG","justifyContentRight":"bpYR8G"};